import React from 'react'
import { priceFormat } from '../../../../../assets/scripts/GeneralFunctions'

function ServiceItem({ title, icon, text }) {
  return (
    <div className="w-full sm:w-fit min-w-[250px] h-32 bg-light-blue border border-inactive-link rounded-xl dark:bg-slate-800">
      <div className="flex items-center justify-between px-5 py-4 border-b">
        <span className={'text-black text-lg font-medium dark:text-amber-100'}>{title}</span>
        <i className={`${icon} text-secondary text-2xl pr-4 dark:text-amber-100`} />
      </div>
      <div className="flex items-center justify-start px-5 py-4">
        <span className={'text-lg text-normal dark:text-slate-100'}>
          {text ? priceFormat(text) : '- - -'}
        </span>
      </div>
    </div>
  )
}

export default React.memo(ServiceItem)
